module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.collapsed) ? _c('h1', [_vm._v(_vm._s(_vm.$t('pageTitle', 'home')))]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    staticClass: "header-dropdown",
    attrs: {
      "trigger": "hover"
    }
  }, [_c('el-button', {
    staticClass: "header-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.getCurrentLanguageDisplayName()) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    class: {
      'is-active': _vm.currentLanguage === 'zh-CN'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('zh-CN')
      }
    }
  }, [(_vm.currentLanguage === 'zh-CN') ? _c('i', {
    staticClass: "el-icon-check"
  }) : _vm._e(), _vm._v("\n\t\t\t\t\t\t简体中文\n\t\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-item', {
    class: {
      'is-active': _vm.currentLanguage === 'zh-TW'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('zh-TW')
      }
    }
  }, [(_vm.currentLanguage === 'zh-TW') ? _c('i', {
    staticClass: "el-icon-check"
  }) : _vm._e(), _vm._v("\n\t\t\t\t\t\t繁體中文\n\t\t\t\t\t")]), _vm._v(" "), _c('el-dropdown-item', {
    class: {
      'is-active': _vm.currentLanguage === 'en'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.switchLanguage('en')
      }
    }
  }, [(_vm.currentLanguage === 'en') ? _c('i', {
    staticClass: "el-icon-check"
  }) : _vm._e(), _vm._v("\n\t\t\t\t\t\tEnglish\n\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.currentTexts.logout))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return [(!item.hidden) ? _c('div', {
      key: index
    }, [(!item.leaf && (item.path == '/' || _vm.menusPath.includes(item.path))) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(_vm.getMenuName(item.name)))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return [(!child.hidden && _vm.menusPath.includes(child.path)) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getMenuName(child.name)) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()]
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0 && _vm.menusPath.includes(item.children[0].path)) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(_vm.getMenuName(item.children[0].name)))]) : _vm._e()], 1) : _vm._e()]
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return [(!item.hidden) ? _c('li', {
      key: index,
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_vm._l((item.children), function(child) {
      return [(!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getMenuName(child.name)) + "\n\t\t\t\t\t\t\t\t\t")]) : _vm._e()]
    })], 2)] : [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px",
        "min-width": "60px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])]], 2) : _vm._e()]
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getMenuName(_vm.$route.name)))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.getMenuName(item.name)) + "\n\t\t\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed07a3ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 197
// module chunks = 25